"use strict";

exports.__esModule = true;
exports.percentageValueFormatter = exports.durationValueFormatter = exports.defaultValueFormatter = void 0;
var _Utils = require("../../../Utils");
var defaultValueFormatter = exports.defaultValueFormatter = function defaultValueFormatter(value) {
  return value;
};
var durationValueFormatter = exports.durationValueFormatter = function durationValueFormatter(value) {
  return value !== undefined ? (0, _Utils.formatDuration)(value, false) : "";
};
var percentageValueFormatter = exports.percentageValueFormatter = function percentageValueFormatter(value) {
  return value !== undefined ? Math.round(value * 100) + "%" : "";
};